import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import SideMenubar from './SideMenubar';
import TopHeader from './TopHeader';

import '../../global.css';

const TABLET_BREAKPOINT = 1024;
const TABLET_MEDIA_QUERY = `(max-width: ${TABLET_BREAKPOINT}px)`;

const getInitialCollapsed = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.innerWidth <= TABLET_BREAKPOINT;
};

const Layout = ({ logout }) => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(getInitialCollapsed);
    const [adminInfo, setAdminInfo] = useState({});

    const adminCheckAPI = async () => {
        try {
            const response = await RefreshCheckApi.get('/admin/check');
            const nextAdminInfo = response.data.info;
            setAdminInfo(nextAdminInfo);
        } catch (error) {
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('expires_at');
            localStorage.removeItem('user_id');
            localStorage.removeItem('user');
        }
    };

    useEffect(() => {
        localStorage.getItem('user_id');
    }, [navigate]);

    useEffect(() => {
        adminCheckAPI();
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const mediaQuery = window.matchMedia(TABLET_MEDIA_QUERY);
        const handleViewportChange = (event) => {
            setCollapsed(event.matches);
        };

        setCollapsed(mediaQuery.matches);

        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', handleViewportChange);

            return () => {
                mediaQuery.removeEventListener('change', handleViewportChange);
            };
        }

        mediaQuery.addListener(handleViewportChange);

        return () => {
            mediaQuery.removeListener(handleViewportChange);
        };
    }, []);

    return (
        <LayoutRoot>
            <SideMenubar collapsed={collapsed} adminInfo={adminInfo} setCollapsed={setCollapsed} />
            <MainPanel>
                <TopHeader logout={logout} adminInfo={adminInfo} />
                <MainBody className="main">
                    <MainRightSide className="main-right-side">
                        <OutletContainer>
                            <Outlet />
                        </OutletContainer>
                    </MainRightSide>
                </MainBody>
            </MainPanel>
        </LayoutRoot>
    );
};

export default React.memo(Layout);

const LayoutRoot = styled.div`
    display: flex;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    background-color: #f2f4f6;
`;

const MainPanel = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
`;

const MainBody = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background-color: #f2f4f6;
`;

const MainRightSide = styled.div`
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: auto;
`;

const OutletContainer = styled.div`
    min-height: 100%;
    padding: 2%;
    box-sizing: border-box;
`;
